import { useForm, useFormContext } from 'react-hook-form';

import { RoadmapNode, RoadmapNodeStatus } from '@/api/rest/resources/types/organization';

export const WORKSTREAM_FORM_KEYS = {
  TITLE: 'title',
  DESCRIPTION: 'description',
  PLOT_GROUPS: 'plotGroups',
  MILESTONES: 'milestones',
  INDICATOR_PRODUCTS: 'indicatorProducts',
  PROGRESS: 'progress',
} as const;

export type WorkstreamCreateFormFieldValues = {
  [WORKSTREAM_FORM_KEYS.TITLE]: string;
  [WORKSTREAM_FORM_KEYS.DESCRIPTION]: string;
  [WORKSTREAM_FORM_KEYS.PLOT_GROUPS]: string[];
  [WORKSTREAM_FORM_KEYS.PROGRESS]: number | undefined;
  [WORKSTREAM_FORM_KEYS.INDICATOR_PRODUCTS]: string[];
  [WORKSTREAM_FORM_KEYS.MILESTONES]: Partial<RoadmapNode>[];
};
export const useWorkstreamCreateForm = useForm<WorkstreamCreateFormFieldValues>;
export const useWorkstreamCreateContext = useFormContext<WorkstreamCreateFormFieldValues>;

export const EMPTY_MILESTONE: Partial<RoadmapNode> = {
  title: '',
  description: '',
  status: RoadmapNodeStatus.created,
  children: [],
};

export const ROOT_ROADMAP_NODE_INDEX = 0;
